import React from "react";
import { LuClock as Clock } from "react-icons/lu";
import { SectionHeader } from "../section-header";
import { StatCard } from "../stat-card";
import { StatsByCategoryMap } from "../../types";
import { calcPercentage } from "../../utils/stats.util";

type Props = {
  stats: StatsByCategoryMap["SLOTS"];
  expiry: number;
};

export const SlotsStatsSection: React.FC<Props> = ({ stats, expiry }) => {
  return (
    <div className="mb-8">
      <SectionHeader icon={Clock} title="Time Slots Statistics" updateInfo={expiry} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard icon={Clock} title="Total Slots" value={stats.TOTAL_SLOTS.count} />
        <StatCard
          icon={Clock}
          title="Slots (Last Month)"
          value={stats.LAST_MONTH_SLOTS.count}
          change={`${calcPercentage(stats.TOTAL_SLOTS.count, stats.LAST_MONTH_SLOTS.count)}%`}
        />

        <StatCard
          icon={Clock}
          title="Available Slots"
          value={stats.AVAILABLE_SLOTS.count}
          change={`${calcPercentage(stats.TOTAL_SLOTS.count, stats.AVAILABLE_SLOTS.count)}% of Total`}
          changeColor="text-blue-600"
        />

        <StatCard
          icon={Clock}
          title="Booked Slots"
          value={stats.BOOKED_SLOTS.count}
          change={`${calcPercentage(stats.TOTAL_SLOTS.count, stats.BOOKED_SLOTS.count)}% of Total`}
          changeColor="text-blue-600"
        />
      </div>
    </div>
  );
};
